/* ============================================================
   cro-ajustes.js — ajustes de conversão no carrinho lateral (02/09/2026)
   Roda depois de theme.js e finalizacao.js (defer, mesma ordem no layout).
   Não altera os arquivos originais: reorganiza o drawer já criado e
   acrescenta a sugestão para fechar o frete grátis.
   Para reverter: remover o <script> em layout/theme.liquid.
   ============================================================ */
(function () {
  'use strict';

  var cfg = window.RobustaCartConfig || {};
  var THRESHOLD = parseInt(cfg.freeShippingThreshold, 10) || 14990;
  var UPSELL = Array.isArray(cfg.upsell) ? cfg.upsell : [];

  function money(cents) {
    if (window.RobustaCart && typeof window.RobustaCart.formatMoney === 'function') {
      return window.RobustaCart.formatMoney(cents);
    }
    return 'R$ ' + ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',');
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* ── 1. Reorganiza o drawer: avisos para o rodapé, cupom atrás de link ── */
  function arrangeDrawer() {
    var popup = document.querySelector('.cart-popup');
    if (!popup || popup.hasAttribute('data-cro-ready')) return false;
    popup.setAttribute('data-cro-ready', 'true');

    var foot = popup.querySelector('.cart-popup__foot');
    var info = popup.querySelector('.cart-popup__info-carousel');
    var shipping = popup.querySelector('[data-free-shipping-bar]');
    var discount = popup.querySelector('.cart-popup__discount');

    // avisos (prazo / golpe) saem do topo e vão para depois dos botões
    if (info && foot) {
      info.classList.add('cart-info-carousel--foot');
      foot.appendChild(info);
    }

    // cupom começa fechado; abre por um link discreto
    if (discount && foot) {
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'cart-discount__toggle';
      toggle.setAttribute('data-discount-toggle', '');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Tenho um cupom';
      discount.setAttribute('hidden', '');
      foot.insertBefore(toggle, discount);
      toggle.addEventListener('click', function () {
        var open = discount.hasAttribute('hidden');
        if (open) {
          discount.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          var input = discount.querySelector('[data-discount-input]');
          if (input) input.focus();
        } else {
          discount.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // container da sugestão, logo abaixo da barra de frete
    if (shipping && !popup.querySelector('[data-cart-upsell]')) {
      var up = document.createElement('div');
      up.className = 'cart-popup__upsell';
      up.setAttribute('data-cart-upsell', '');
      up.setAttribute('hidden', '');
      shipping.insertAdjacentElement('afterend', up);
    }
    watchDrawer();
    return true;
  }

  /* ── 2. Sugestão para fechar o frete grátis ── */
  function pickUpsell(cart) {
    var inCart = {};
    var inCartProducts = {};
    (cart.items || []).forEach(function (it) {
      inCart[String(it.variant_id)] = true;
      inCartProducts[String(it.product_id)] = true;
    });
    var candidates = UPSELL.filter(function (p) {
      return p && p.variantId && !inCart[String(p.variantId)] && !inCartProducts[String(p.productId)];
    });
    var remaining = THRESHOLD - (cart.total_price || 0);
    var closes = candidates.filter(function (p) { return p.price >= remaining; })
      .sort(function (a, b) { return a.price - b.price; });
    var others = candidates.filter(function (p) { return p.price < remaining; })
      .sort(function (a, b) { return b.price - a.price; });
    return closes.slice(0, 1).concat(others.slice(0, 1)).concat(closes.slice(1, 2)).slice(0, 2);
  }

  function renderUpsell(cart) {
    var box = document.querySelector('[data-cart-upsell]');
    if (!box || !cart) return;
    var empty = !cart.items || cart.items.length === 0;
    var reached = (cart.total_price || 0) >= THRESHOLD;
    if (empty || reached) { box.setAttribute('hidden', ''); box.innerHTML = ''; return; }

    var picks = pickUpsell(cart);
    if (!picks.length) { box.setAttribute('hidden', ''); box.innerHTML = ''; return; }

    var remaining = THRESHOLD - cart.total_price;
    box.innerHTML =
      '<p class="cart-upsell__label">Leve junto e feche o frete grátis</p>' +
      '<div class="cart-upsell__list">' +
        picks.map(function (p) {
          var closes = p.price >= remaining;
          return '<div class="cart-upsell__item">' +
            '<img class="cart-upsell__img" src="' + esc(p.image) + '" alt="" width="44" height="44" loading="lazy">' +
            '<div class="cart-upsell__meta">' +
              '<p class="cart-upsell__title">' + esc(p.title) + '</p>' +
              '<p class="cart-upsell__price">' + money(p.price) + (closes ? ' · frete grátis' : '') + '</p>' +
            '</div>' +
            '<button type="button" class="cart-upsell__btn" data-upsell-add="' + esc(p.variantId) + '">Adicionar</button>' +
          '</div>';
        }).join('') +
      '</div>';
    box.removeAttribute('hidden');
  }

  function addVariant(variantId, btn) {
    if (btn) btn.disabled = true;
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    return fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.RobustaCart && typeof window.RobustaCart.refresh === 'function') {
          window.RobustaCart.refresh(cart);
        }
        renderUpsell(cart);
        // contador do header, se existir
        document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { if (btn) btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    addVariant(btn.getAttribute('data-upsell-add'), btn);
  });

  /* ── 3. Engancha no refresh do carrinho (finalizacao.js) ── */
  function hookRefresh() {
    if (!window.RobustaCart || typeof window.RobustaCart.refresh !== 'function') return false;
    if (window.RobustaCart.refresh.__croWrapped) return true;
    var original = window.RobustaCart.refresh;
    var wrapped = function (cart) {
      var out = original.apply(this, arguments);
      try { arrangeDrawer(); renderUpsell(cart); } catch (err) { /* nunca quebra o carrinho */ }
      return out;
    };
    wrapped.__croWrapped = true;
    window.RobustaCart.refresh = wrapped;
    return true;
  }

  /* ── 3b. finalizacao.js chama o refresh interno (não o window.RobustaCart.refresh)
     ao remover/alterar quantidade. Por isso observamos o próprio drawer: quando a
     barra de frete ou a lista de itens é redesenhada, relemos o carrinho e
     atualizamos a sugestão (debounce para não repetir chamadas). ── */
  var syncTimer = null;
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderUpsell(cart); })
        .catch(function () {});
    }, 120);
  }
  function watchDrawer() {
    var popup = document.querySelector('.cart-popup[data-cro-ready]');
    if (!popup || popup.__croWatched) return;
    var targets = [
      popup.querySelector('[data-free-shipping-bar]'),
      popup.querySelector('[data-cart-popup-items]')
    ].filter(Boolean);
    if (!targets.length) return;
    popup.__croWatched = true;
    var obs = new MutationObserver(scheduleSync);
    targets.forEach(function (t) { obs.observe(t, { childList: true, subtree: true, characterData: true }); });
  }

  function boot() {
    arrangeDrawer();
    watchDrawer();
    hookRefresh();
    // estado inicial: lê o carrinho uma vez para montar a sugestão
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { arrangeDrawer(); renderUpsell(cart); })
      .catch(function () {});
  }

  // theme.js cria o drawer no DOMContentLoaded; garantimos ordem com um tick
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 0); });
  } else {
    setTimeout(boot, 0);
  }

  // o drawer pode ser criado tarde (initCartPopup) — observa e reorganiza uma vez
  var mo = new MutationObserver(function () {
    if (arrangeDrawer()) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); }).then(renderUpsell).catch(function () {});
    }
    if (document.querySelector('.cart-popup[data-cro-ready]')) mo.disconnect();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
